/**
 * A collection of String-based constants.
 * @hidden
 * @ignore Exclude from docs
 */

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let PX: string = "px";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let STRING: string = "string";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let NUMBER: string = "number";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let DATE: string = "date";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let DURATION: string = "duration";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let PLACEHOLDER: string = "__§§§__";

/**
 * @ignore Exclude from docs
 * @type {string}
 */
export let PLACEHOLDER2: string = "__§§§§__";


// WEBPACK FOOTER //
// ../../../../../src/.internal/core/utils/Strings.ts